export function Spinner() {
  return (
    <div className="flex items-center justify-center">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-t-transparent border-blue-500"></div>
    </div>
  );
}
